import type { KnowledgeResponse } from "entities/knowledge/types";
import type { ErrorMeta } from "types/redux";

export enum KnowledgeActionTypes {
  FETCH_FOR_ID = "entities/KNOWLEDGE_FETCH_FOR_ID",
  FETCH_FOR_ID_SUCCESS = "entities/KNOWLEDGE_FETCH_FOR_ID_SUCCESS",
  FETCH_FOR_ID_FAILURE = "entities/KNOWLEDGE_FETCH_FOR_ID_FAILURE",
}

export type KnowledgeItemDefaultAction = {
  meta: { id: string; forceRefresh?: boolean };
  type: KnowledgeActionTypes.FETCH_FOR_ID;
};

export type KnowledgeItemFulfilledAction = {
  meta: { id: string };
  payload: KnowledgeResponse;
  type: KnowledgeActionTypes.FETCH_FOR_ID_SUCCESS;
};

export type KnowledgeItemRejectedAction = {
  meta: ErrorMeta & { id: string };
  type: KnowledgeActionTypes.FETCH_FOR_ID_FAILURE;
};

export type KnowledgeItemAction =
  | KnowledgeItemDefaultAction
  | KnowledgeItemFulfilledAction
  | KnowledgeItemRejectedAction;
